import React from 'react'
import Link from 'gatsby-link';
import { withTranslation } from 'react-i18next';

function Footer({t, language}){

    return (
        <footer className="footer_4 bg_white padding_top65 padding_bottom30">
        	<div className="container nopadding">
        		<div className="row">
        			<div className="col-xl-6 bottom20">
        				<img src="/images/duuers-logo.svg" className="height30" alt="logo"/>
        			</div>
        			<div className="col-xl-6 bottom35 text-xl-right top5 links">
        			    <a className="font16 link dark_blue left35" href="https://medium.com/duuers/tarjouspohja-8328677b3f06">{t('footer.links.freeTemplate')}</a>
        			    <a className="font16 link dark_blue left35" href="https://learn.duuers.com">{t('footer.links.support')}</a>
        			    <a className="font16 link dark_blue left35" href="https://thehub.fi/jobs/company/duuers">{t('footer.links.jobs')}</a>
                        <Link className="font16 link dark_blue left35" to={`${language ? language : ''}/terms/`}>{t('footer.links.termsOfUse')}</Link>
                        <Link className="font16 link dark_blue left35" to={`${language ? language : ''}/privacy/`}>{t('footer.links.privacyPolicy')}</Link>
        			</div>
        		</div>
        		<div className="bottom40 hr height1 light_gray"></div>
        		<div className="max_width870 bottom15 float_left font16 light medium_gray footer_text">
        		   Copyright © 2019 Duuers
        		</div>
        		<div className="float_right socials">
        			<a href="https://www.instagram.com/Duuers_Insta/" className="font18 link medium_gray left30"><i className="fa fa-instagram"></i></a>
        			<a href="https://twitter.com/duuers" className="font18 link medium_gray left30"><i className="fa fa-twitter"></i></a>
        			<a href="https://www.facebook.com/duuers" className="font18 link medium_gray left30"><i className="fa fa-facebook-square"></i></a>
        			<a href="https://www.linkedin.com/company/16203578" className="font18 link medium_gray left30"><i className="fa fa-linkedin-square"></i></a>
        		</div>
        		<div className="clearfix"></div>
        	</div>
        </footer>
      );
  }

export default withTranslation()(Footer);
